export const COLORS = {
    orange: '#FF9900',
    blue: '#527FFF',
    purple: '#A166FF',
    // your colors
}